import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, MenuItem, Select, InputLabel, FormControl, Typography, CircularProgress } from '@mui/material';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { MainContainer, ChatContainer, MessageList, MessageInput, Message } from '@chatscope/chat-ui-kit-react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import './App.css';

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
}

function ChatPublicPage() {
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [threadId, setThreadId] = useState(null);
  const [runId, setRunId] = useState(null);
  const [selectedState, setSelectedState] = useState('');
  const [visitorId, setVisitorId] = useState(null);
  const navigate = useNavigate();
  const [canChat, setCanChat] = useState(false);
  const [unlockedAnswer, setUnlockedAnswer] = useState(false);
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [unlockEmail, setUnlockEmail] = useState('');
  const [id, setId] = useState(null);
  const [reply, setReply] = useState('');
  const [question, setQuestion] = useState('');
  const [streamBuffer, setStreamBuffer] = useState('');
  const bufferRef = React.useRef('');
  const bufferTimeout = React.useRef(null);
  
  useEffect(() => {
    setLoading(true);
    FingerprintJS.load().then(fp => {
      fp.get().then(result => {
        setVisitorId(result.visitorId);

        fetch(`${process.env.REACT_APP_API_URL}/public-chat?visitor_id=${result.visitorId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${process.env.REACT_APP_API_TOKEN}`,
          }
        })
          .then(response => response.json())
          .then(data => {
            if (data && data.length > 0) {
              setCanChat(false);

              if (data[0].id) {
                setId(data[0].id);

                var returnAnswer = data[0].answer;
                if (data[0].email != '' && data[0].email != null) {
                 returnAnswer = data[0].answer;
                }
                else {
                  setShowEmailDialog(true);
                }

                setMessages([
                  { content: data[0].question, direction: 'outgoing' },
                  { content: returnAnswer, direction: 'incoming' }
                ]);

              }
            }
            else {
              setCanChat(true);
            }
            setLoading(false);
          })
          .catch(error => console.error('Error fetching public chat data:', error));
      });
    });
  }, []);

  const handleSendMessage = (message) => {
    if (!canChat) { 
      alert('You have already used your one free chat.');
      return;
    }

    if (!selectedState) {
      alert('Please select a state before chatting.');
      return;
    }

    setCanChat(false);
    
    setQuestion(message);

    setMessages([...messages, { content: message, direction: 'outgoing' }]);

    const thinkingMessage = { content: "We're thinking...", direction: 'incoming' };
    setMessages(prevMessages => [...prevMessages, thinkingMessage]);
    
      var myRunId = null;
      var myThreadId = null;
      var myPublicChatId = null;

      fetchEventSource(`${process.env.REACT_APP_API_URL}/public-stream?question=${encodeURIComponent(message)}&state=${selectedState}&visitor_id=${visitorId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Token ${process.env.REACT_APP_API_TOKEN}`,
          'Accept': 'text/event-stream',
        },
        onmessage(ev) {
          const data = JSON.parse(ev.data);

          if (data.event == 'thread.message.created' || data.event == 'thread.message.in_progress') {
            //console.log(data.event);
            //console.log(data.data);
          }
    
          if (data.event == 'thread.run.created') {
            myRunId = data.data.id;
            myThreadId = data.data.thread_id;
            myPublicChatId = data.public_chat_id;
          }
          else if (data.event == 'thread.message.delta') {
            console.log(data.data);
            if (data?.data?.delta?.content) {
              data.data.delta.content.forEach((contentItem) => {
                if (contentItem.type === 'text' && contentItem.text && contentItem.text.value) {
                  setReply((prevReply) => {
                    const updatedReply = prevReply + contentItem.text.value;
                    setMessages(prevMessages => {
                      const newMessages = [...prevMessages];
                      newMessages[newMessages.length - 1] = { content: updatedReply, direction: 'incoming' };
                      return newMessages;
                    });
                    return updatedReply;
                  });
                }
              });
            } else {
              console.warn('Delta content is undefined or missing:', data);
            }            
          }
          else if (data.event == 'thread.run.completed') {
            return get_final_answer(myRunId, myThreadId, myPublicChatId);
          }
        },
        onerror(err) {
          console.error('Streaming error:', err);
        }
      });
  };

  const get_final_answer = (myRunId, myThreadId, myPublicChatId) => {
  
    setRunId(myRunId);
    setThreadId(myThreadId);
    setId(myPublicChatId);
    
    fetch(`${process.env.REACT_APP_API_URL}/public-chat/poll?thread_id=${myThreadId}&run_id=${myRunId}&visitor_id=${visitorId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${process.env.REACT_APP_API_TOKEN}`,
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.text_response != null) {
            // setMessages([
            // { content: data.question, direction: 'outgoing' },
            // { content: data.text_response, direction: 'incoming' }
            // ]);
          setShowEmailDialog(true);
        }
      })
      .catch(error => console.error('Error fetching final answer:', error));
  };
    
  const unlock = () => {
    if (!unlockEmail.trim()) {
      alert('Please enter your email address');
      return;
    }

    if (!isValidEmail(unlockEmail.trim())) {
      alert('Please enter a valid email address');
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL}/public-chat/${id}/?visitor_id=${visitorId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${process.env.REACT_APP_API_TOKEN}`,
      },
      body: JSON.stringify({
        email: unlockEmail.trim(),
      }),
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Failed to unlock the answer.');
      }
    })
    .then(data => {
      setMessages([
        { content: question, direction: 'outgoing' },
        { content: data.answer, direction: 'incoming' }
      ]);

      setUnlockedAnswer(true);
      setShowEmailDialog(false);
    })
    .catch(error => {
      console.error('Error unlocking answer:', error);
      alert('An error occurred. Please try again later.');
    });
  };

  const states = [
    { value: 'US', label: 'United States' }, { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' }, { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' }, { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' }, { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' }, { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' }, { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' }, { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' }, { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' }, { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' }, { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' }, { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' }, { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },{ value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' }, 
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' }, 
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' }, { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' }, { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' }, 
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },{ value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' }, { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' }, { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' }, { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' }, { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' }, 
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },{ value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
  ];

  return (
    <Box sx={{ padding: 3 }}>
      {loading ? (
        <Box display="flex" flexDirection="column" alignItems="center" mt={6}>
          <CircularProgress size={50} />
        </Box>
      ) : (
        <>
          {!canChat && unlockedAnswer ? (
            <Box
              sx={{
                position: 'fixed', // Make it fixed to the viewport
                top: 0,
                left: 0,
                width: '100%',
                height: '195px',
                backgroundColor: 'rgba(230, 230, 230, 0.7)', // Semi-transparent background
                backdropFilter: 'blur(4px)', // Apply blur effect
                zIndex: 20, // Ensure it sits above other content
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 4,
              }}
            >
            <h2 style={{ textAlign: 'center' }}> Want more? </h2>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
            <a
              className="odoo-btn-primary"
              href="https://www.civiclyenvolved.com/plans"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'white' }}
            >
              Plans
            </a>
            <a
              className="odoo-btn-primary"
              href="https://www.civiclyenvolved.com/contactus"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'white' }}
            >
              Questions
            </a>
            <a
              className="odoo-btn-primary"
              href="https://www.civiclyenvolved.com/book-a-time"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'white' }}
            >
              Demos
            </a>
            </Box>
            </Box>
            ) : (
            <Box
            sx={{
              textAlign: 'center',
              marginBottom: 4,
            }}
            >
            <Typography variant="h3" gutterBottom>
              Try our Chatbot
            </Typography>
            
            </Box>
            )}
            <Box
            sx={{
              display: 'flex', // Use flexbox to align items side by side
              justifyContent: 'center', // Center align the dropdowns
              gap: 2, // Add spacing between the dropdowns
              flexWrap: 'wrap', // Allow wrapping on smaller screens
              mb: 2, // Add margin below the container
            }}
            >
            {/* Select a State Dropdown */}
            <FormControl
              sx={{
                minWidth: 100, // Minimum width of 100px
                maxWidth: '25%', // Maximum width of 25% of the screen
                flex: 1, // Allow flexibility for responsiveness
              }}
              size="medium"
            >
              <InputLabel id="state-select-label">Select a State</InputLabel>
              <Select
                labelId="state-select-label"
                value={selectedState}
                label="Select a State"
                onChange={(e) => setSelectedState(e.target.value)}
                sx={{
                  width: '100%', // Ensure it takes up the full width of its container
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      width: 'auto',
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select a State
                </MenuItem>
                {states.map((state) => (
                  <MenuItem key={state.value} value={state.value}>
                    {state.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Select a Year/Session Dropdown */}
            <FormControl
              sx={{
                minWidth: 100, // Minimum width of 100px
                maxWidth: '25%', // Maximum width of 25% of the screen
                flex: 1, // Allow flexibility for responsiveness
              }}
              size="medium"
            >
              <InputLabel id="session-select-label">Select a Year/Session</InputLabel>
              <Select
                labelId="session-select-label"
                value="Current" // Default value is "Current"
                label="Select a Year/Session"
                onClick={() => {
                  alert("If you'd like to see prior sessions, please sign up for access.");
                }}
                sx={{
                  width: '100%', // Ensure it takes up the full width of its container
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      width: 'auto',
                    },
                  },
                }}
                disabled={true} // Keep the dropdown disabled
              >
                <MenuItem value="Current">Current</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', border: 'none', outline: 'none' }}>
            {/* Message Input at the Top */}
            <Box
              sx={{
                position: 'relative', // Position relative to allow flexibility
                // top: '5%', // Place it 10% from the top
                width: '70%', // Set width to 70%
                margin: '0 auto', // Center it horizontally
                zIndex: 10, // Ensure it stays on top
                backgroundColor: 'white',
                padding: '20px',
              }}
            >
              <MessageInput
                placeholder="Ask about a bill or an issue..."
                onSend={handleSendMessage}
                attachButton={false}
                style={{
                  border: 'none', // Remove border
                  outline: 'none', // Remove outline
                }}
                />
              </Box>

              {/* Main Container Below the Input */}
              <MainContainer
                sx={{
                flex: 1, // Allow it to take up remaining space
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto', // Allow the container to expand and scroll only when necessary
                border: 'none',
                outline: 'none',
                height: 'auto', // Adjust height to fit its contents
                }}
              >
                <ChatContainer
                sx={{
                  flex: 1,
                  overflowY: 'auto', // Allow the container to expand and scroll only when necessary
                  border: 'none',
                  outline: 'none',
                  height: 'auto', // Adjust height to fit its contents
                }}
                >
                <MessageList
                  style={{
                  border: 'none',
                  outline: 'none',
                  }}
                >
                  {messages.map((message, index) => (
                  <Message
                    key={index}
                    model={{
                    message: message.content,
                    sentTime: 'just now',
                    sender: 'User',
                    direction: message.direction,
                    }}
                  />
                  ))}
                </MessageList>
                </ChatContainer>
              </MainContainer>

            {unlockedAnswer && (
              <Box
                sx={{
                  position: 'relative', // Position relative to allow overlay
                  marginTop: 4, // Add spacing above the table
                  padding: 2, // Add padding around the table
                  backgroundColor: 'white', // White background for the table
                  borderRadius: 2, // Optional: Add rounded corners
                  boxShadow: 3, // Optional: Add a shadow for better visibility
                }}
              >
                
                {/* Blurred Overlay */}
              <Box
                sx={{
                  position: 'absolute', // Position absolute to overlay on the table
                  top: '300px', // Start from the top of the parent box
                  bottom: 0, 
                  left: 0,
                  width: '100%', // Cover the full width of the table
                  backgroundColor: 'rgba(230, 230, 230, 0.75)', // Semi-transparent background
                  backdropFilter: 'blur(6px)', // Apply blur effect
                  zIndex: 2, // Ensure it sits above the table content
                }}
              >
                <h2 style={{ textAlign: 'center' }}> Get access to the full list </h2>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                <a
                  className="odoo-btn-primary"
                  href="https://www.civiclyenvolved.com/plans"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'white' }}
                >
                  Plans
                </a>
                <a
                  className="odoo-btn-primary"
                  href="https://www.civiclyenvolved.com/contactus"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'white' }}
                >
                  Questions
                </a>
                <a
                  className="odoo-btn-primary"
                  href="https://www.civiclyenvolved.com/book-a-time"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'white' }}
                >
                  Demos
                </a>
                </Box>
                </Box>
              </Box>
            )}
          </Box>


          {/* Disclaimer at the bottom */}
          <Typography
            variant="body2"
            sx={{
              textAlign: 'center',
              color: 'black',
              mt: 'auto', // pushes it to the bottom
              py: 2, // optional: add some padding
            }}
          >
            <b>Disclaimer:</b> AI is experimental and may not always provide accurate answers.
            Please check the source documents for the most accurate information.
          </Typography>


          
        <Dialog open={showEmailDialog}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: 'rgba(230, 230, 230, 0.75)', // White semi-transparent background
              backdropFilter: 'blur(6px)', // Apply blur effect
              position: 'absolute',
              top: '50%',
              bottom: 0,
              left: 0,
              right: 0,
            },
          },
        }}>
          <DialogTitle>Unlock Full Answer</DialogTitle>
          <DialogContent>
            <Typography>
              To unlock the full answer, please supply your email address:
            </Typography>
            <TextField
              type="email"
              placeholder="Enter your email"
              value={unlockEmail}
              onChange={(e) => setUnlockEmail(e.target.value)}
              fullWidth
              sx={{ mt: 1, mb: 1 }}
            />
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={unlock}>
              Submit
            </Button>
          </DialogActions>
        </Dialog>

      </>
    )}
  </Box>
  );
}

export default ChatPublicPage;